module.exports = __webpack_public_path__ + "img/case-logo-37.9a098647.png";